import React from 'react';
import { Card, Form, Input, DatePicker, Row, Col } from 'antd';

const PatientInfo = ({ form }) => {
  return (
    <Card title="Patient Information" style={{ marginBottom: '24px' }}>
      <Form form={form} layout="inline">
        <Row gutter={16} style={{ width: '100%' }}>
          <Col xs={24} sm={12} md={6}>
            <Form.Item name="patientName" label="Patient Name">
              <Input placeholder="Enter patient name" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item name="patientId" label="Patient ID">
              <Input placeholder="Enter patient ID" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item name="visitDate" label="Visit Date">
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Form.Item name="dentistName" label="Dentist">
              <Input placeholder="Dr. Name" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default PatientInfo;